import processInclude from 'base/util';
import newsletter from './newsletter/newsletter';

const init = (): void => processInclude(newsletter);

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
